import { DiagramResponseBase } from "abweb/dto/generated/gds/DiagramResponseBase";
export class DiagramResponse extends DiagramResponseBase {
  constructor() {
    super();
  }
}
//# sourceMappingURL=DiagramResponse.js.map
